import {
  WC2026_ORG_ONE_TIME_ACCESS_LABEL,
} from '../../shared/constants/wc2026OrgBillingDisclosure.constants'

/**
 * Summary line for paid one-time Business orgs (Plan & billing).
 */
export function buildOrgOneTimePaidAccessSummary(maxSeats: number): string {
  const seats =
    Number.isFinite(maxSeats) && maxSeats > 0
      ? `Up to ${maxSeats} member seats`
      : 'Member seats per your plan'
  return `${WC2026_ORG_ONE_TIME_ACCESS_LABEL} · ${seats}`
}
